import { produce } from 'immer';

const INITIAL_STATE = {
  loading: false,
  customizationLoaded: false,
};

export default function loading(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@loading/SET_GLOBAL_LOADING': {
        draft.loading = !state.loading;
        break;
      }
      case '@loading/SET_GLOBAL_CUSTOMIZATION_LOADED': {
        draft.customizationLoaded = !state.customizationLoaded;
        break;
      }

      default:
        return INITIAL_STATE;
    }
  });
}
